import { render, staticRenderFns } from "./IngestResultBoard.vue?vue&type=template&id=294ae770&scoped=true"
import script from "./IngestResultBoard.vue?vue&type=script&lang=js"
export * from "./IngestResultBoard.vue?vue&type=script&lang=js"
import style0 from "./IngestResultBoard.vue?vue&type=style&index=0&id=294ae770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294ae770",
  null
  
)

export default component.exports